// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"s4-z"};